import { ActionTree } from 'vuex';
import { State } from './wsm.store';
import { AxiosResponse } from 'axios';
import graphQl from '@/services/graphQl';
import { Context, Params } from '@/utils/types/global';
import graphHelpers from '@/utils/graphHelper';

const actions: ActionTree<State, any> = {
  getWSMServices(context: Context, params: { duration: any; serviceReq: any }) {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'D'
      };
    }
    return graphQl
      .query('queryServices')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setWSMServices', res.data.data.services);
        if (res.data.data.services.length > 0) {
          const curService = res.data.data.services.find(
            ser =>
              ser.key ===
              context.rootState.wsmState.wsmCommonState.currentWSMService.key
          );
          context.commit(
            'setCurrentWSMService',
            curService || res.data.data.services[0]
          );
        } else {
          context.commit('setCurrentWSMService', '');
        }
      });
  },
  getWSMGraphData(context: Context, params: Params) {
    const normal = true;
    let config = graphHelpers.createConfigWSM(context, params);
    if (!config || !config.metricName || !config.queryMetricType) {
      return;
    }
    const { currentWSMService } = context.rootState.wsmState.wsmCommonState;
    const { currentWSMInstance } = context.rootState.wsmState.detail;
    const metricNames = graphHelpers.parse(config.metricName);
    const labels = graphHelpers.parse(config.labelsIndex || '');
    const variablesList: Array<any> = metricNames.map((name: string) => {
      let variables = {} as any;
      variables = {
        duration: params.duration,
        condition: {
          name: config.metricName,
          entity: {
            scope: 'Endpoint',
            serviceName: currentWSMService.key,
            endpointName: currentWSMInstance.key,
            normal
          }
        },
        labels
      };
      return variables;
    });

    if (!variablesList || !variablesList.length) {
      return;
    }

    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return graphQl
            .graphQuery(variable, config.queryMetricType)
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              return {
                ...resData,
                config,
                metricName: variable.condition.name
              };
            });
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    });
  }
};

export default actions;
